<div class="row justify-content-center mt-4 mb-5">
  <div class="col-12 col-md-10 col-lg-7">
    <div class="card">
      <div class="card-body p-4 p-md-5">
        <h1 class="page-title noselect">Contact Us</h1>
        <p class="page-subtitle noselect">
          Have a question or need to schedule service? Send us a message and
          we'll get back to you as soon as we can.
        </p>

        <app-contact-form></app-contact-form>

        <div class="direct-contact noselect">
          <p class="direct-contact-label">Prefer to reach us directly?</p>
          <a class="direct-contact-link" [href]="'tel:' + phone">
            <i class="fas fa-phone"></i> {{ displayPhone }}
          </a>
          <p class="direct-contact-address">{{ address }}</p>
        </div>
      </div>
    </div>
  </div>
</div>
